module.exports = __webpack_public_path__ + "img/arrow-down-f.7909f791.svg";